import { useTranslation } from 'react-i18next'
import type { AdminActivityEvent } from './adminTypes'
import { formatWhen } from './adminUtils'

type Props = {
  items: AdminActivityEvent[]
}

export default function AdminActivityFeed({ items }: Props) {
  const { t, i18n } = useTranslation()

  if (!items.length) {
    return <p className="vc-admin-muted">{t('admin.activityEmpty')}</p>
  }

  return (
    <ul className="vc-admin-activity">
      {items.map((event, index) => (
        <li
          key={`${event.type}-${event.entity_id ?? index}-${event.at ?? index}`}
          className={`vc-admin-activity__item${event.severity === 'danger' ? ' is-danger' : ''}`}
        >
          <span className="vc-admin-activity__time">{formatWhen(event.at, i18n.language)}</span>
          <div className="vc-admin-activity__body">
            <strong>{t(`admin.activity.${event.type}`, { defaultValue: event.type })}</strong>
            <span>{event.label}</span>
            {event.meta ? <span className="vc-admin-muted">{event.meta}</span> : null}
          </div>
        </li>
      ))}
    </ul>
  )
}
